import React from "react";
import TrackVisibility from "react-on-screen";
import Funfact from "../Items/Funfact";

const funfactData = [
  {
  id: 1,
  title: "Projects website",
  count: 10,
  icon: "icon-globe", // globe = web
},
{
  id: 2,
  title: "Projects analysis data",
  count: 10,
  icon: "icon-graph", // graph = data analysis
},
{
  id: 3,
  title: "Organizational Activities",
  count: 5,
  icon: "icon-people", // people = organization
},
{
  id: 4,
  title: "Awards won",
  count: 6,
  icon: "icon-trophy", // tetap relevan
},

];

function Funfacts() {
  return (
    <section className="shadow-dark color-white background parallax padding-50">
      <div className="row relative z-1 -mt-50">
        {funfactData.map((funfact) => (
          <div className="col-md-3 col-sm-6 mt-50" key={funfact.id}>
            <TrackVisibility once>
              <Funfact funfact={funfact} />
            </TrackVisibility>
          </div>
        ))}
      </div>
      <div className="overlay1"></div>
    </section>
  );
}

export default Funfacts;
